import React from 'react';

import { Button, Modal, ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';

export default function DeleteModal({ event, organization, resetPagination, open, onClose }) {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);
    const [isDeleting, setIsDeleting] = React.useState(false);

    const onSubmit = React.useCallback(() => {
        setIsDeleting(true);
        event
            .delete({
                organizationId: organization.id,
                eventId: event.id
            })
            .then(() => {
                toast.success(t('eventList.deleteModal.toast-success'));
                onClose();
                resetPagination();
                setIsDeleting(false);
            })
            .catch(e => {
                console.error(e);
                toast.error(t('eventList.deleteModal.toast-error'));
                setIsDeleting(false);
            });
    }, [event, organization, toast, resetPagination, onClose]);

    return (
        <Modal
            allowExternalClosing={false}
            open={open}
            onClose={onClose}
            submitButton={<Button primary label={t('ticket.common.action.delete')} onClick={onSubmit} isLoading={isDeleting} />}
            cancelButton={<Button onClick={onClose} label={t('ticket.common.action.cancel')} disabled={isDeleting} />}
            title={t('eventList.deleteModal.title')}
        >
            <div style={{ marginTop: '15px' }}>{t('eventList.deleteModal.description')}</div>
        </Modal>
    );
}
